export const SUPPORTED_LOCALES = [
  {
    code: "en",
    name: "English"
  },
  {
    code: "es",
    name: "Spanish"
  },
  {
    code: "id",
    name: "Bahasa"
  }
];
